import { IField, IDatePicker } from 'app/services/api5-service/api.interface';
import { of } from 'rxjs';

import { FieldSettings } from 'common/dynamic-form/wrappers/field-base/model';

import { DatePickerProps } from './model/date-picker-props.interface';

import {
  ISPFieldConfig,
  ISPFieldType,
  ISPFieldWrapper,
  ISPFormState,
} from '../../model';

/**
 * Get datepicker display mode
 *
 * @param control
 */
function getDatepickerDisplayMode(
  control: IDatePicker,
): DatePickerProps['datePickMode'] {
  // @WARN Can be change to inline if renders in filter chip
  switch (true) {
    case control.$time === 'yes':
      return 'time';
    case control.$date === 'month':
      return 'month';
    default:
      return 'date';
  }
}

/**
 * Get props for date-picker field
 *
 * @param control - control (subfield) metadata
 * @param field - field metadata
 * @param state - dynamic form state
 */
export function getDatePickerProps(
  control: IDatePicker,
  field: IField,
  state: ISPFormState,
): DatePickerProps {
  return {
    originalControl: control,
    originalField: field,
    fieldSettings$: of({
      displayMode: 'input-like',
      tagPlace: 'field',
    } as FieldSettings),
    datePickMode: getDatepickerDisplayMode(control),
    mask: control.$mask,
    placeholder$: state.mixedService.getControlPlaceholder$(
      control,
      ISPFieldType.DatePicker,
    ),
  };
}

/**
 * Get config for date-picker field
 *
 * @param control - control (subfield) metadata
 * @param field - field metadata
 * @param state - dynamic form state
 */
export function getDatePickerConfig(
  control: IDatePicker,
  field: IField,
  state: ISPFormState,
): ISPFieldConfig<ISPFieldType.DatePicker> {
  const props = getDatePickerProps(control, field, state);

  const config: ISPFieldConfig<ISPFieldType.DatePicker> = {
    key: control.$name,
    type: ISPFieldType.DatePicker,
    wrappers: [ISPFieldWrapper.FieldBase, ISPFieldWrapper.ValidationError],
    props,
  };

  return config;
}
